import { useContext, useEffect, useState } from "react"
import { FormContextProvider } from "context/FormContext"
import { ApplicationDataParser } from "components/ApplicationDataParser"
import { generateValidationSchema } from "utilities/schema"
import { UserContext } from "context/UserContext"
import { AuthContext } from "context/AuthContext"
import { TealiumLinkTrack } from "tealium"
import { lessThanOneMinuteAgo } from "utilities/helpers"
import { ClientContext } from "context/ClientContext"
import { IS_PRODUCTION } from "utilities/constants"
import { ApplicationData } from "types"
import { LayoutProvider } from "./LayoutProvider"

export const Authenticated = (localAppData: ApplicationData) => {
  const { token } = useContext(AuthContext)
  const { user } = useContext(UserContext)
  const { client } = useContext(ClientContext)
  const [validationSchema, setValidationSchema] = useState<any>()
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false)

  const applicationData = IS_PRODUCTION ? client.data : localAppData

  useEffect(
    function logFormDataForDevelopment() {
      if (!IS_PRODUCTION) {
        console.groupCollapsed("Form Data For Development")
        console.groupCollapsed("App JSON")
        console.log(JSON.stringify(applicationData, null, "\t"))
        console.groupEnd()
        console.groupCollapsed("Form Values")
        console.log(user.applicationData)
        console.groupEnd()
        console.groupEnd()
      }
    },
    [applicationData, user.applicationData],
  )

  useEffect(() => {
    async function setFaviconAndPageTitle() {
      const favicon: HTMLLinkElement = document.querySelector("#favicon")
      if (applicationData.meta && favicon) {
        favicon.href = applicationData.meta.favicon
        document.title = `${applicationData.meta.title}`
      }
    }
    setFaviconAndPageTitle()
  }, [applicationData.meta])

  useEffect(
    function generateValidations() {
      if (client && !validationSchema) {
        const validations = generateValidationSchema(applicationData)
        setValidationSchema(validations)
      }
    },
    [applicationData, client, validationSchema],
  )

  useEffect(
    function setDataLoadedAndNewUser() {
      // @ts-ignore
      if (client && validationSchema) {
        setIsDataLoaded(true)

        // @ts-ignore
        if (lessThanOneMinuteAgo(user.createdAt) && window.utag) {
          TealiumLinkTrack({
            tealium_event: "app_start",
            email_address: user.email,
          })
        }
      }
    },

    // @ts-ignore
    // eslint-disable-next-line
    [client, user, validationSchema, window.utag],
  )

  return (
    <FormContextProvider
      validationSchema={validationSchema}
      user={user}
      token={token}
    >
      <LayoutProvider
        applicationData={applicationData}
        isDataLoaded={isDataLoaded}
      >
        <ApplicationDataParser {...applicationData} />
      </LayoutProvider>
    </FormContextProvider>
  )
}
